import React from 'react';

/*
 * RadioIcon — 24×24 circular chassis with optional 10×10 darker-blue dot.
 *
 * Renders both the icon (unchecked) and checkedIcon (checked) for MUI's
 * Radio via the .hd-radio-icon className. State styling (border colors,
 * hover/focus/error/disabled) lives in src/theme/components.ts → MuiRadio
 * styleOverrides which cascade through MUI's class names + custom .hd-radio-*
 * selectors. This component just contributes the chassis + dot DOM hooks.
 *
 * Dot geometry sourced from the Figma source.json (any True variant's Ellipse
 * node): 10×10 centered inside the 24×24 chassis. Background is currentColor
 * so the parent .hd-radio-icon's `color` token drives the dot color
 * (--hd-c-radio-dot-fg, inverted to --hd-c-radio-dot-fg-disabled in the
 * Mui-disabled cascade).
 */
export const RadioIcon: React.FC<{ checked?: boolean }> = ({ checked = false }) => (
  <span className={`hd-radio-icon${checked ? ' hd-radio-icon--checked' : ''}`}>
    {checked && <span className="hd-radio-icon__dot" aria-hidden />}
  </span>
);
